import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import moment from "moment";
import DatePicker from "../../common/date-picker";
import { intlShape, injectIntl } from "react-intl";
import { Textfield } from "cxa-components";
import FormField from "./FormField";
import messages from "components/messagesDescription";

const INVALID_DATE_FORMAT = "@@INVALID_DATE_FORMAT@@";

const formatDate = dateFormat => value => {
  if (!value) {
    return null;
  }
  const date = moment(value);
  return date.isValid() ? date : null;
};

const normalizeDate = dateFormat => value => {
  if (!value) {
    return null;
  }
  // enforce moment's strict parsing
  const date = moment.isMoment(value) ? value : moment(value, dateFormat, true);
  return date.isValid() ? date.format("YYYY-MM-DD[T]HH:mm:ssZ") : INVALID_DATE_FORMAT;
};

const renderDatePicker = ({
  value,
  color,
  error,
  onBlur,
  maxDate,
  minDate,
  dateFormat,
  helpText,
  ...props
}) => (
  <Fragment>
    <DatePicker
      {...props}
      dateFormat={dateFormat}
      openToDate={maxDate}
      maxDate={maxDate}
      minDate={minDate}
      onBlur={val => onBlur(val)}
      isClearable
      customInput={<Textfield boxed error={error} color={color} />}
      selected={value}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      fixedHeight
    />
    {helpText && helpText != "#void help text#" && <div className="help-text">{helpText}</div>}
  </Fragment>
);

renderDatePicker.propTypes = {
  value: PropTypes.object,
  error: PropTypes.any,
  onBlur: PropTypes.func,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  dateFormat: PropTypes.string,
};

const renderReadOnlyDate = ({ value, dateFormat, ...props }) => (
  <Textfield {...props} value={value ? moment(value).format() : ""} />
);

renderReadOnlyDate.propTypes = {
  value: PropTypes.string,
  dateFormat: PropTypes.string,
};

class DateField extends Component {
  constructor(props) {
    super(props);
    const { intl, validate } = props;
    this.validateDateFormat = this.validateDateFormat.bind(this, this.format, intl);
    this.validation = (validate ? [].concat(validate) : []).concat(this.validateDateFormat);
  }

  validateDateFormat(dateFormat, intl, value) {
    return value !== INVALID_DATE_FORMAT
      ? undefined
      : intl.formatMessage(messages.invalidDateFormat, { dateFormat });
  }

  render() {
    const { props } = this;
    const { readOnly, label } = props;
    if (readOnly) {
      return <FormField component={renderReadOnlyDate} boxed {...props} />;
    }

    const format = moment.localeData().longDateFormat(moment.defaultFormat);
    const fieldLabel = `${label} (${format})`;

    return (
      <FormField
        {...props}
        label={fieldLabel}
        component={renderDatePicker}
        format={formatDate(format)}
        normalize={normalizeDate(format)}
        validate={this.validation}
        dateFormat={format}
      />
    );
  }
}

DateField.propTypes = {
  intl: intlShape.isRequired,
  dateFormat: PropTypes.string,
  validate: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
  readOnly: PropTypes.bool,
  defaultFormat: PropTypes.bool,
};

export default injectIntl(DateField);



// WEBPACK FOOTER //
// ./components/common/form-field/DateField.js